export function headerMenu() {
  const menuButton = document.getElementById('menu-button');
  const header = document.querySelector('.l-header');
  const menuLinks = document.querySelectorAll('.l-header a'); 
  const menuEntry = document.querySelector('.l-header__menu-entry');
  const headerHeight = header.offsetHeight;


  // メニューボタンをクリックしてメニューを開閉する
  menuButton.addEventListener('click', () => {
    header.classList.toggle('menu-open');
    menuButton.classList.toggle('is-active');
  });

  // メニューの外をクリックしたらメニューを閉じる
  document.addEventListener('click', (event) => {
    if (!header.contains(event.target) && !menuButton.contains(event.target)) {
      header.classList.remove('menu-open');
      menuButton.classList.remove('is-active');
    }
  });

  // メニュー内のリンクをクリックしたらメニューを閉じる
  menuLinks.forEach(link => {
    link.addEventListener('click', () => {
      header.classList.remove('menu-open');
      menuButton.classList.remove('is-active');
    });
  });

  // トップページでのmenu-entryの表示処理
  if (window.location.pathname === '/recruit/') {
    const toggleMenuEntryVisibility = () => {
      if (window.innerWidth < 769) {
        if (window.scrollY > 100) {
          menuEntry.classList.add('is-visible');
        } else {
          menuEntry.classList.remove('is-visible');
        }
      } else {
        menuEntry.classList.add('is-visible');
      }
    };

    window.addEventListener('scroll', toggleMenuEntryVisibility);
    window.addEventListener('resize', toggleMenuEntryVisibility);
    toggleMenuEntryVisibility();
  } else {
    menuEntry.classList.add('is-visible');
  }

  // スクロールによる背景色変更
  const mainElement = document.querySelector('main');
  const isTopPage = mainElement && mainElement.id === 'top';
  const heroElement = document.querySelector('.p-home-hero');
  const headingInner = document.querySelector('.c-heading__inner');

  if (isTopPage && heroElement) {
    const heroHeight = heroElement.offsetHeight;

    if (window.scrollY > heroHeight) {
      header.classList.add('scrolled');
    }

    window.addEventListener('scroll', function() {
      if (window.scrollY > heroHeight) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });
  } else if (headingInner) {
    const headingInnerPosition = headingInner.offsetHeight;

    // スクロール時にheadingInner位置を過ぎたときに背景色を変更
    window.addEventListener('scroll', function() {
      if (window.scrollY > headingInnerPosition - headerHeight ) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });
  } else {
    header.classList.add('scrolled');
  }
}
